var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "games",
    clipPath: "url(#clip0_1002_44688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "games_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3079 12.7701C16.8838 12.346 16.1962 12.346 15.7721 12.7701C15.3479 13.1942 15.3479 13.8819 15.7721 14.306C16.1962 14.7301 16.8838 14.7301 17.3079 14.306C17.732 13.8819 17.732 13.1942 17.3079 12.7701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0759 10.4663C18.5 10.0422 19.1876 10.0422 19.6117 10.4663C20.0359 10.8904 20.0359 11.578 19.6117 12.0022C19.1876 12.4263 18.5 12.4263 18.0759 12.0022C17.6518 11.578 17.6518 10.8904 18.0759 10.4663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9155 12.7701C21.4914 12.346 20.8038 12.346 20.3797 12.7701C19.9556 13.1942 19.9556 13.8819 20.3797 14.306C20.8038 14.7301 21.4914 14.7301 21.9155 14.306C22.3397 13.8819 22.3397 13.1942 21.9155 12.7701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0759 15.0739C18.5 14.6498 19.1876 14.6498 19.6117 15.0739C20.0359 15.498 20.0359 16.1857 19.6117 16.6098C19.1876 17.0339 18.5 17.0339 18.0759 16.6098C17.6518 16.1857 17.6518 15.498 18.0759 15.0739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02392 14.6241H4.85188V12.452H7.02392V10.28H9.19595V12.452H11.368V14.6241H9.19595V16.7961H7.02392V14.6241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10994 5.93591C3.9114 5.93591 0.507812 9.3395 0.507812 13.538C0.507812 17.7366 3.9114 21.1402 8.10994 21.1402H18.9701C23.1687 21.1402 26.5722 17.7366 26.5722 13.538C26.5722 9.3395 23.1687 5.93591 18.9701 5.93591H8.10994ZM18.9701 8.10795H8.10994C5.11098 8.10795 2.67985 10.5391 2.67985 13.538C2.67985 16.537 5.11098 18.9681 8.10994 18.9681H18.9701C21.9691 18.9681 24.4002 16.537 24.4002 13.538C24.4002 10.5391 21.9691 8.10795 18.9701 8.10795Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_44688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0644,
    height: 26.0644,
    fill: "white",
    transform: "translate(0.507812 0.505859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.498861a46f7ec5a79f4262a2fb856433.svg";
export { ForwardRef as ReactComponent };